import { FC, useState } from 'react';
import { useAppData } from '../../../contexts/appData';
import { Dropdown, DropdownAlignment } from '../../shared/dropdown/dropdown';
import { Icon } from '../../shared/icons/icon';
import { DepartmentSelector, DepartmentSelectorDirection, DepartmentSelectorMode } from '../../shared/inputs/departmentSelector';
import styles from './signedInDepartments.module.css';

export const SignedInDepartments: FC<{
    displayOnly?: boolean,
}> = ({ displayOnly = false }) => {
    const [expanded, setExpanded] = useState(false);

    const {
        departments,
        userInfo,
        setSignedInDepartments,
    } = useAppData();
    
    return <Dropdown
        expanded={expanded}
        onChange={setExpanded}
        width='500px'
        alignment={DropdownAlignment.Left}
        dropContents={
            <DepartmentSelector
                className={styles.DepartmentSelector}
                value={userInfo?.activeDepartments ?? []}
                onChange={setSignedInDepartments}
                direction={DepartmentSelectorDirection.Row}
                mode={DepartmentSelectorMode.Multiple}
            />}
    >
        <button className={styles.SignedInDepartments} onClick={() => { if (!displayOnly) setExpanded(!expanded) }}>
            <div className={styles.SignedInDepartmentsText}>
                Signed in as
            </div>

            <div className={styles.SignedInDepartmentsIcons}>
                {(userInfo?.activeDepartments ?? []).map(d => <Icon key={d} src={departments.find(dd => dd.id === d)?.icon} />)}
            </div>
        </button>
       
    </Dropdown>
}